import { readStoredValue, writeStoredValue } from './storedValue'

const DIRTY_FORM_KEY = 'dirtyForm'

let dirtyForm = readStoredValue(DIRTY_FORM_KEY) === 'true'

export const getDirtyForm = (): boolean => dirtyForm

export const setDirtyForm = (dirty: boolean): void => {
  dirtyForm = dirty
  writeStoredValue(DIRTY_FORM_KEY, String(dirty))
}
